import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useGetReportsTransaction } from 'core/hooks/api'

// Styled Elements
import { TableWrapper } from './ReportsTransactionTable.elements'

// Views
import { Table, EmptyTablePlaceholder, LoadingTablePlaceholder } from 'views/components'
import { ReportsTransactionTableFilter } from 'views/layouts'

import ReportsTransactionTableHeader from '../ReportsTransactionTableHeader'
import ReportsTransactionTableItem from '../ReportsTransactionTableItem'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function ReportsTransactionTable(props) {
  // Destructure
  const { filters, ui, actions } = props

  // Store States
  const { reportsTransactionFilters } = filters
  const { isPageTableUpdated } = ui
  const { setIsPageTableUpdated, setReportsTransactionFilters, showAlert } = actions

  // Hooks
  const {
    getReportsTransaction,
    getReportsTransactionData,
    getReportsTransactionError,
    isGetReportsTransactionLoading,
  } = useGetReportsTransaction()

  // Local states
  const [reports, setReports] = useState([])
  const [pagination, setPagination] = useState()

  // Functions
  const fetchData = () => {
    getReportsTransaction(reportsTransactionFilters)
  }

  useEffect(() => fetchData(), [reportsTransactionFilters])
  useEffect(() => {
    if (isPageTableUpdated) {
      fetchData()
      setIsPageTableUpdated(false)
    }
  }, [isPageTableUpdated])
  useEffect(() => {
    if (getReportsTransactionData) {
      setReports(getReportsTransactionData.items)
      setPagination(getReportsTransactionData.pagination)
    }
  }, [getReportsTransactionData])
  useEffect(() => {
    // TODO ADD PROPER ERROR MSG SENT FROM SERVER
    if (getReportsTransactionError) showAlert({ type: 'error', message: 'An error occurred in fetching reports' })
  }, [getReportsTransactionError])
  return (
    <TableWrapper>
      <Table
        totalItems={pagination?.total && pagination.total}
        minWidth={900}
        tableFilters={reportsTransactionFilters}
        setTableFilters={setReportsTransactionFilters}
      >
        <ReportsTransactionTableFilter />
        <ReportsTransactionTableHeader />
        {reports.length > 0 && !isGetReportsTransactionLoading && (
          <>
            {reports.map((data) => (
              <ReportsTransactionTableItem key={data.id} data={data} />
            ))}
          </>
        )}
        {reports.length < 1 && (
          <div>
            {isGetReportsTransactionLoading ? (
              <LoadingTablePlaceholder />
            ) : (
              <EmptyTablePlaceholder setFilter={setReportsTransactionFilters} />
            )}
          </div>
        )}
      </Table>
    </TableWrapper>
  )
}

// Default Props
ReportsTransactionTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
ReportsTransactionTable.propTypes = {
  filters: PropTypes.shape({
    reportsTransactionFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    setToBeUpdatedAccount: PropTypes.func,
    setAccountDirectoryFilters: PropTypes.func,
    setIsIndividualAccountDrawerOpen: PropTypes.func,
    setIsEntityAccountDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setReportsTransactionFilters: PropTypes.func,
    showAlert: PropTypes.func,
    toggleUpgradeModal: PropTypes.func,
    setInfoModalDetails: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsTransactionTable)
